import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static classes = ["hide"]
  static values = { after: { type: Number, default: 5000 } }

  connect() {
    super.connect()

    this.element.classList.add(...this.hiddenClasses)
    this.timer = setTimeout(() => this.reveal(), this.afterValue)
  }

  disconnect() {
    super.disconnect()

    if (this.timer) clearTimeout(this.timer)
  }

  reveal = () => {
    this.element.classList.remove(...this.hiddenClasses)
  }

  get hiddenClasses() {
    return this.hasHideClass ? this.hideClasses : ["invisible"]
  }
}
